import DuckEntity from './DuckEntity'

const entity = new DuckEntity('appointments', {
  jsonRoot: 'appointment_detail',
});
const reducer = entity.reducer;
export {reducer as default, entity};
